var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('VueApexCharts',{ref:"dialogChart",attrs:{"type":"line","options":_vm.chartOptions,"series":_vm.chartSeries,"width":"100%","height":_vm.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }